import 'youtube-background';

export default class HomeIntro {
    
    static get selector() {
        return '.homeIntro';
    }

    constructor(el) {
        this.el = el;
        //this.video = this.el.querySelector('.homeIntro__video');
        //this.loadYoutube();
        //this.setEvents();

        new VideoBackgrounds('[data-youtube]',{
            
        });
    }

    loadYoutube() {

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    buildPlayer() {
        console.log('buildPlayer');

        this.player = new YT.Player( this.video, {
            width: '100%',
            height: '100%',
            videoId: 'dQw4w9WgXcQ',
            playerVars: {
                'autoplay': 1,
                'showinfo': 0,
                'autohide': 1,
                'loop': 1,
                'controls': 0,
                'modestbranding': 1,
                'vq': 'hd1080'
            },
            events: {
                'onReady': this.e_PlayerReady.bind(this),
                'onStateChange': this.e_StateChange.bind(this)
            }
        });
    }

    setEvents() {
        window.addEventListener('youtubeloaded', this.e_youTubeLoaded.bind(this));
    }
    
    e_youTubeLoaded(event) {
        this.buildPlayer();
    }

    e_PlayerReady(event) {
        event.target.playVideo();
        this.player.mute(); // comment out if you don't want the auto played video muted
    }

    e_StateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
            this.player.seekTo(0);
            this.player.playVideo();
        }
    }




}